/* tslint:disable */
/* eslint-disable */
/**
 * Price and Capacity Track & automatic reserve Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddPriceTrackRequest } from '../model';
// @ts-ignore
import { Int32PriceTrackResponse } from '../model';
// @ts-ignore
import { ObjectPriceTrackResponse } from '../model';
// @ts-ignore
import { PriceTrackListResponse } from '../model';
// @ts-ignore
import { SetAlertRequest } from '../model';
/**
 * PriceTrackApiApiPriceTrackAddPost - axios parameter creator
 * 
 * @param {AddPriceTrackRequest} [addPriceTrackRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PriceTrackApiApiPriceTrackAddPostAxiosParamCreator (addPriceTrackRequest?: AddPriceTrackRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/PriceTrack/Add`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addPriceTrackRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PriceTrackApiApiPriceTrackCancelPost - axios parameter creator
 * 
 * @param {number} [priceHash] 
 * @param {number} [priceTrackId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PriceTrackApiApiPriceTrackCancelPostAxiosParamCreator (priceHash?: number, priceTrackId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/PriceTrack/Cancel`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (priceHash !== undefined) {
        localVarQueryParameter['priceHash'] = priceHash;
    }

    if (priceTrackId !== undefined) {
        localVarQueryParameter['priceTrackId'] = priceTrackId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PriceTrackApiApiPriceTrackRedirectGet - axios parameter creator
 * 
 * @param {number} [priceHash] 
 * @param {number} [priceTrackId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PriceTrackApiApiPriceTrackRedirectGetAxiosParamCreator (priceHash?: number, priceTrackId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/PriceTrack/redirect`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (priceHash !== undefined) {
        localVarQueryParameter['priceHash'] = priceHash;
    }

    if (priceTrackId !== undefined) {
        localVarQueryParameter['priceTrackId'] = priceTrackId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PriceTrackApiApiPriceTrackSetAlertPost - axios parameter creator
 * 
 * @param {SetAlertRequest} [setAlertRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PriceTrackApiApiPriceTrackSetAlertPostAxiosParamCreator (setAlertRequest?: SetAlertRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/PriceTrack/SetAlert`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(setAlertRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PriceTrackApiApiPriceTrackTrackListGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PriceTrackApiApiPriceTrackTrackListGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/PriceTrack/TrackList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiPriceTrackAddPost operation in PriceTrackApi.
 * @export
 * @interface PriceTrackApiApiPriceTrackAddPostRequest
 */
export interface PriceTrackApiApiPriceTrackAddPostRequest {
    /**
     * 
     * @type {AddPriceTrackRequest}
     * @memberof PriceTrackApiApiPriceTrackAddPost
     */
    readonly addPriceTrackRequest?: AddPriceTrackRequest
}

/**
 * Request parameters for apiPriceTrackCancelPost operation in PriceTrackApi.
 * @export
 * @interface PriceTrackApiApiPriceTrackCancelPostRequest
 */
export interface PriceTrackApiApiPriceTrackCancelPostRequest {
    /**
     * 
     * @type {number}
     * @memberof PriceTrackApiApiPriceTrackCancelPost
     */
    readonly priceHash?: number

    /**
     * 
     * @type {number}
     * @memberof PriceTrackApiApiPriceTrackCancelPost
     */
    readonly priceTrackId?: number
}

/**
 * Request parameters for apiPriceTrackRedirectGet operation in PriceTrackApi.
 * @export
 * @interface PriceTrackApiApiPriceTrackRedirectGetRequest
 */
export interface PriceTrackApiApiPriceTrackRedirectGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PriceTrackApiApiPriceTrackRedirectGet
     */
    readonly priceHash?: number

    /**
     * 
     * @type {number}
     * @memberof PriceTrackApiApiPriceTrackRedirectGet
     */
    readonly priceTrackId?: number
}

/**
 * Request parameters for apiPriceTrackSetAlertPost operation in PriceTrackApi.
 * @export
 * @interface PriceTrackApiApiPriceTrackSetAlertPostRequest
 */
export interface PriceTrackApiApiPriceTrackSetAlertPostRequest {
    /**
     * 
     * @type {SetAlertRequest}
     * @memberof PriceTrackApiApiPriceTrackSetAlertPost
     */
    readonly setAlertRequest?: SetAlertRequest
}

/**
* 
* @param {PriceTrackApiApiPriceTrackAddPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PriceTrackApiApiPriceTrackAddPost(requestParameters: PriceTrackApiApiPriceTrackAddPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PriceTrackApiApiPriceTrackAddPostAxiosParamCreator(requestParameters.addPriceTrackRequest, options, configuration);
    const request: () => AxiosPromise<Int32PriceTrackResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PriceTrackApiApiPriceTrackCancelPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PriceTrackApiApiPriceTrackCancelPost(requestParameters: PriceTrackApiApiPriceTrackCancelPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PriceTrackApiApiPriceTrackCancelPostAxiosParamCreator(requestParameters.priceHash, requestParameters.priceTrackId, options, configuration);
    const request: () => AxiosPromise<ObjectPriceTrackResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PriceTrackApiApiPriceTrackRedirectGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PriceTrackApiApiPriceTrackRedirectGet(requestParameters: PriceTrackApiApiPriceTrackRedirectGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PriceTrackApiApiPriceTrackRedirectGetAxiosParamCreator(requestParameters.priceHash, requestParameters.priceTrackId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PriceTrackApiApiPriceTrackSetAlertPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PriceTrackApiApiPriceTrackSetAlertPost(requestParameters: PriceTrackApiApiPriceTrackSetAlertPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PriceTrackApiApiPriceTrackSetAlertPostAxiosParamCreator(requestParameters.setAlertRequest, options, configuration);
    const request: () => AxiosPromise<Int32PriceTrackResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PriceTrackApiApiPriceTrackTrackListGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PriceTrackApiApiPriceTrackTrackListGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<PriceTrackListResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
